<template>
  <footer class="footer">
  <div class="content">
    <div class="columns">
      <div class="column has-text-left is-one-fifth is-offset-one-fifth">
        <img src="dvoslant.png" alt="">
      </div>
      <div class="column has-text-left is-one-fifth is-offset-two-fifths">
      <p>
        <span class="DVO_SUSPENSION">
        DVO SUSPENSION INC.
        </span>
        <br>
        <br>
        <span class="DVO_UNDERWRITING">
        25026 Anza Drive Unit B
        </span>
        <br>
        <span class="DVO_UNDERWRITING">
        Valencia CA, 91335
        </span>
        <br>
        <span class="DVO_UNDERWRITING">
        USA
        </span>
        <br>
        <span class="DVO_UNDERWRITING">
        (661) 295-95000
        </span>
        <br>
      </p>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {

}
</script>

<style scoped>
.DVO_SUSPENSION{
  font-family:  'Anton', sans-serif;
  border-bottom: 2px solid #82bc00;
  font-size: 20pt;
}
.DVO_UNDERWRITING{
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
  color: #868686;
}
</style>